import React from "react";
import { Button } from "react-bootstrap";
import classNames from 'classnames';
import ModalBase from "../modals/ModalBase";
import PlanHeader from "./PlanHeader";
import SinglePlanFeatures from "./SinglePlanFeatures";

import "../../../assets/sass/components/plans/plan-modal.scss";

class SinglePlanModal extends ModalBase {
    
    renderBody = () => {
        const { plan } = this.props;

        return (
            <SinglePlanFeatures plan={plan} />
        )
    };
    
    renderHeader = () => {
        const { plan } = this.props;

        return (
            <PlanHeader plan={plan} />
        );
    };

    renderFooter = () => {
        const { footerText, btnText } = this.props;

        return (
            <>
                <Button variant="primary" size="md" block>{btnText}</Button>
                <p className="text">{footerText}</p>
            </>
        )
    };

    modalClassname = () => classNames("plan-modal", this.props.plan);

    static defaultProps = {
        size: "sm",
        plan: "gold",
        footerText: "Platinum Membership offers all features",
        btnText: "Upgrade To Platinum"
    };
}

export default SinglePlanModal;
